module.exports = __webpack_public_path__ + "static/media/KHOF02.481e541d.jpg";